import { render, staticRenderFns } from "./wine-sales.vue?vue&type=template&id=cb20d646&scoped=true&"
import script from "./wine-sales.vue?vue&type=script&lang=js&"
export * from "./wine-sales.vue?vue&type=script&lang=js&"
import style0 from "./wine-sales.vue?vue&type=style&index=0&id=cb20d646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb20d646",
  null
  
)

export default component.exports